import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppService from "../../../services/app.service";
import Loader from "../../../components/loader";
import AlertDialogSlide from "../../../components/deleteModal";
import Table from "../../../components/Table";
import Layout from "../../../layout/Layout";
import auth from "../../../services/auth";
import AssignSimulations from "../educataor-insights-dashboard/AssignSimulations";

let cohort = "";
let selected = {};
const Cohort = (props) => {
  const [cohorts, setCohorts] = useState([]);
  const [isShowingModal, setIsShowingModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cohortId, setCohortId] = useState(0);
  const [openAssignSimModal, setOpenAssignSimModal] = useState(false);
  const [isShowingDelinkModal, setIsShowingDelinkModal] = useState(false);
  const [columnSchema] = useState([
    {
      dataField: "id",
      text: "ID",
      sort: true,
      classes: "content-body",
      headerStyle: { minWidth: 50 },
      headerClasses: "table_header_color",
      align: "left",
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      classes: "name content-body",
      headerClasses: "table_header_color",
      align: "left",
      headerStyle: { minWidth: 200 },
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
      classes: "paragraph-in-table content-body",
      headerClasses: "table_header_color",
      align: "left",
      headerStyle: { minWidth: 250 },
    },
    {
      dataField: "active",
      text: "Status",
      sort: true,
      classes: "active text-center content-body",
      headerClasses: "text-center table_header_color",
      align: "left",
      formatter: (cell) => (cell ? "Active" : "InActive"),
      headerStyle: { minWidth: 100 },
    },
    {
      dataField: "action",
      text: "Action",
      classes: "action text-center",
      headerStyle: { width: 200 },
      headerClasses: "text-center",
      align: "center",
      formatter: (_, cohort) => {
        return (
          <Fragment>
            <Link
              className="btn btn-primary btn-sm"
              to={`/cohorts/edit/${cohort.id}`}
              style={{ marginRight: "5px" }}
            >
              <i className="fa fa-edit" title="Edit Cohort" />
            </Link>
            <button
              className="btn btn-danger btn-sm buttons"
              onClick={() => deleteCohort(cohort.id, cohort.name)}
              style={{ marginRight: "5px" }}
            >
              <i className="fa fa-trash" title="Delete Cohort" />
            </button>
            {cohort.active && (
              <button
                className="btn btn-primary btn-sm"
                onClick={() => handleAssignSimModal(cohort)}
                style={{ marginRight: "5px" }}
              >
                <i className="fas fa-link" title="Assign Sims" />
              </button>
            )}
            {cohort.active && (
              <button
                className="btn btn-danger btn-sm buttons"
                onClick={() => delinkSims(cohort.id, cohort.name)}
                style={{ marginLeft: "5px" }}
              >
                <i className="fa fa-unlink" title="Bulk unlink simulations" />
              </button>
            )}
          </Fragment>
        );
      },
    },
  ]);

  const authenticatedUserDetail = auth.getUserDetails();

  const handleOpenDeleteModal = () => setIsShowingModal(true);
  const handleCloseDeleteModal = () => setIsShowingModal(false);

  const deleteCohort = (cohortId, name) => {
    setCohortId(cohortId);
    cohort = name;
    handleOpenDeleteModal();
  };

  const handleAssignSimModal = (selectedCohort) => {
    selected = { label: selectedCohort.name, value: selectedCohort.id };
    handleOpenAssignSimModal();
  };

  const handleOpenAssignSimModal = () => {
    setOpenAssignSimModal(!openAssignSimModal);
  };

  const handleCohortDeletion = async () => {
    handleCloseDeleteModal();
    setLoading(true);
    const cohort = await AppService.delete(cohortId, "cohorts");
    if (cohort.status === 200) {
      setLoading(false);
      console.debug("Cohort Deleted Successfully");
      loadData();
    } else {
      console.debug("Error deleting the cohort");
    }
  };

  const loadData = async () => {
    setLoading(true);
    const cohortsList = await AppService.getAllWithData(
      "cohorts/getAll",
      authenticatedUserDetail?.accId
    );
    setCohorts(cohortsList?.data?.data);
    setLoading(false);
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleDelinkClick = () => {
    setIsShowingDelinkModal(true);
  };

  const handleDelinkClose = () => {
    setIsShowingDelinkModal(false);
  };

  const delinkSims = (cohortId, name) => {
    setCohortId(cohortId);
    cohort = name;
    handleDelinkClick();
  };

  const handleDeLinkProcess = async () => {
    setLoading(true);
    handleDelinkClose();
    const cohorts = await AppService.delete(
      cohortId,
      "cohorts/deactivateCohortAssignments"
    );
    if (cohorts.status === 200) {
      loadData();
    }
    setLoading(false);
  };

  return (
    <div>
      <Layout
        title="Cohort Management"
        history={props.history}
        activeCohortLink={true}
        showBreadCrumb={true}
      >
        <section className="tables">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-close">
                    <div className="dropdown">
                      <Link className="dropdown-toggle" to="/cohorts/add">
                        <i className="fas fa-plus" title="Add Cohort" />
                      </Link>
                    </div>
                  </div>
                  <div className="card-header d-flex align-items-center">
                    <h3 className="sub-heading">Cohorts</h3>
                  </div>

                  <div className="card-body">
                    <div className="table-responsive data-table-wrapper table-heading">
                      <Table
                        data={cohorts}
                        columns={columnSchema}
                        remote={false}
                        id="value"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
      {loading && (
        <div className="overlay">
          <Loader loading={loading} />
        </div>
      )}
      <AlertDialogSlide
        show={isShowingModal}
        handleNo={handleCloseDeleteModal}
        handleYes={handleCohortDeletion}
        title="Delete Cohort"
      >
        <p className="fields-font">
          Are you sure you want to delete the Cohort{" "}
          <span className="span">{cohort}</span> ?
        </p>
      </AlertDialogSlide>
      {openAssignSimModal && (
        <AssignSimulations
          open={openAssignSimModal}
          handleClose={handleOpenAssignSimModal}
          selected={selected}
        />
      )}
      <AlertDialogSlide
        show={isShowingDelinkModal}
        handleNo={handleDelinkClose}
        handleYes={handleDeLinkProcess}
        title="Bulk Unlink Simulations"
        positiveButtonTitle="Delink"
      >
        <p className="fields-font">
          Are you sure you want to delink all the simulations associated with
          the cohort <span className="span">{cohort}</span> ?
        </p>
      </AlertDialogSlide>
    </div>
  );
};

export default Cohort;
